export default __webpack_public_path__ + "static/media/phone.389fa9dc.svg";